module.exports = __webpack_public_path__ + "img/Polokwane_City_FC_logo.63489483.png";